import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerCharterDetailsComponent } from './customer-charter-details.component';
import { CustomerCharterDetailsRoutingModule } from './customer-charter-details-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { SwiperCarouselModule } from '../../shared/public-components/swiper-carousel/swiper-carousel.module';
import { CharterBuyflowVesselDetailResolve } from '../../public/charter-buyflow/charter-buyflow-vessel-detail/charter-buyflow-vessel-detail.resolve';
import { CustomerCaptainPickerModule } from '../../shared/dialogs/customer-captain-picker/customer-captain-picker.module';
import { CustomerBoatRequestDialogModule } from '../../shared/dialogs/customer-boat-request-dialog/customer-boat-request-dialog.module';
import { SharedModule } from '../../shared/shared.module';
import { CustomerPricingDialogModule } from '../../shared/dialogs/customer-pricing-dialog/customer-pricing-dialog.module';
import { HelpDialogModule } from '../../public/help-dialog/help-dialog.module';

@NgModule({
  declarations: [CustomerCharterDetailsComponent],
  imports: [
    CommonModule,
    CustomerCharterDetailsRoutingModule,
    MatCardModule,
    SwiperCarouselModule,
    MatButtonModule,
    CustomerCaptainPickerModule,
    CustomerBoatRequestDialogModule,
    SharedModule,
    HelpDialogModule,
    CustomerPricingDialogModule,
  ],
  providers: [CharterBuyflowVesselDetailResolve],
})
export class CustomerCharterDetailsModule {}
